// src/components/LoadingSpinner.jsx
import React from 'react';
import '../styles/components/LoadingSpinner.scss'; // スピナー用のCSSを別途作成

const LoadingSpinner = () => {
    return (
        <div className="spinner-overlay">
            <div className="spinner"></div>
        </div>
    );
};

export default LoadingSpinner;